import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.png";

export const gripSecurity = defineConnector({
  identifier: "gripSecurity",
  name: "Grip Security",
  tagLine: "SaaS security posture management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.grip\\.security/.*",
  auth: (app) =>
    headerAuth([{ name: "access-token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your Grip Security console, go to **Settings > API** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your Grip Security details",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          placeholder: "your-company.dep.grip.security",
          required: true,
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your Grip Security domain — the first part of your Grip Portal URL (e.g., your-company.dep.grip.security)",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/public/saas`,
  },
  publicEnvVars: ({ domain }) => ({
    GRIP_SECURITY_URL: domain ? `https://${domain}` : "",
  }),
  usageHint: () =>
    "Use process.env.GRIP_SECURITY_URL as the Grip Security base URL. The API is served under the /public base path, e.g. GET ${process.env.GRIP_SECURITY_URL}/public/saas. Authentication is injected automatically.",
});
